__turbopack_context__.v({
  "action": "coT0mG_action",
  "avatar": "coT0mG_avatar",
  "callIcon": "coT0mG_callIcon",
  "caption": "coT0mG_caption",
  "chatHeader": "coT0mG_chatHeader",
  "companion": "coT0mG_companion",
  "composer": "coT0mG_composer",
  "copy": "coT0mG_copy",
  "guide": "coT0mG_guide",
  "identity": "coT0mG_identity",
  "links": "coT0mG_links",
  "messages": "coT0mG_messages",
  "name": "coT0mG_name",
  "panel": "coT0mG_panel",
  "photo": "coT0mG_photo",
  "photoMessage": "coT0mG_photoMessage",
  "preview": "coT0mG_preview",
  "received": "coT0mG_received",
  "section": "coT0mG_section",
  "sent": "coT0mG_sent",
  "srOnly": "coT0mG_srOnly",
});
